import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoice2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-2, siri, wave"><path d="M17.5711 19.3859C12.6791 20.5872 6.86695 11.8999 2.75 11.8999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M4.60156 17.6C10.6226 17.6 14.4989 10 20.4989 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVoice2;
